import { Loading } from '@fasstech/middle-design-system';
import SimulationRecapForm from './SimulationRecapForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import PropTypes from 'prop-types';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import { compose, pathOr } from 'ramda';
import useGetSimulationRecapQuery from './hooks/useGetSimulationRecapQuery.js';

const SimulationRecap = ({
  getMiddleText,
  getMiddleBoolean,
  regimeObligatoire,
  professionalSituations,
  socioProfessionalCategories,
  activities,
  phoneIndicatives,
  internationalPhoneIndicatives,
  viewMode,
  usersInformation
}) => {
  const {
    getSimulationRecap,
    loading: isFetchingGetSimulationRecap
  } =
    useGetSimulationRecapQuery();
  if (isFetchingGetSimulationRecap) return <Loading/>;

  return (
    <SimulationRecapForm
      getSimulationRecap={getSimulationRecap}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      regimeObligatoire={regimeObligatoire}
      professionalSituations={professionalSituations}
      jobs={pathOr([], ['jobs'], getSimulationRecap)}
      socioProfessionalCategories={socioProfessionalCategories}
      activities={activities}
      phoneIndicatives={phoneIndicatives}
      internationalPhoneIndicatives={internationalPhoneIndicatives}
      viewMode={viewMode}
      usersInformation={usersInformation}
    />
  );
};

SimulationRecap.propTypes = {
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func
};

export default compose(withMiddleFeatures, withGlobalData)(SimulationRecap);
